import React from "react";
import Flagship from "../../core/flagship";
import { Table, Loader, Label, Image, Segment } from "semantic-ui-react";
import { empty } from "../../utils/helpers";

class SingleUserView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      confirmExit: false,
      nextLocation: "",
      passwordVisible: false,
      initialPassword: ""
    };
    this.getUserData = this.getUserData.bind(this);
    this.handleUserImageError = this.handleUserImageError.bind(this);
  }

  componentDidMount() {
    this.getUserData();
  }

  getUserData() {
    let self = this;

    Flagship.get(
      "user/" + this.props.routeParams.splat,
      {},
      function(response) {
        if (response.data.success === true) {
          self.setState({
            userData: response.data.user,
            userImage: Flagship.config.uploads + response.data.user.photo
          });
        }
      },
      function(err) {
        Flagship.error(
          "Error getting user data: " + err,
          self.props.routeParams.splat,
          self.props.userId
        );
      }
    );
  }

  handleUserImageError() {
    this.setState({
      userImage: Flagship.config.uploads + "someone.png"
    });
  }

  render() {
    if (typeof this.state.userData === "undefined") {
      return (
        <Table className="fade-in">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="5">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    } else {
      let title =
        parseInt(this.props.routeParams.splat) === this.props.userId
          ? "User :"
          : this.props.username;

      if (
        !empty(this.state.userData.first_name) &&
        !empty(this.state.userData.last_name)
      ) {
        title =
          this.state.userData.first_name + " " + this.state.userData.last_name;
      }

      return (
        <div className="fade-in">
          <div id="view-header-section">
            <h1 className="view-title">{title}</h1>

            <div className="record-meta float-right">
              <Label color="grey" image size="large">
                {this.state.userData.market}
                <Label.Detail>Market</Label.Detail>
              </Label>
            </div>
          </div>

          <Segment className="cf">
            <Image
              className="user-photo-left"
              floated="left"
              className="circular"
              size="small"
              src={this.state.userImage}
              onError={this.handleUserImageError}
            />
            <div className="user-data-right">
              <div className="single-record-single-field">
                <Label>Email Address</Label>
                <div className="field-value">
                  <a href={"mailto:" + this.state.userData.email}>
                    {this.state.userData.email}
                  </a>
                </div>
              </div>

              <div className="single-record-single-field">
                <Label>Phone</Label>
                <div className="field-value">
                  {!empty(this.state.userData.phone) ? (
                    <a href={"tel:+1" + this.state.userData.phone}>
                      {this.state.userData.phone}
                    </a>
                  ) : (
                    <em className="gray-text">Unlisted</em>
                  )}
                </div>
              </div>
            </div>
          </Segment>
        </div>
      );
    }
  }
}

export default SingleUserView;



// WEBPACK FOOTER //
// ./src/components/views/SingleUserView.js